import React from "react";
import { Select as AntSelect, SelectProps as AntSelectProps } from "antd";
import { ReactComponent as Check } from "../../../assets/icons/Check.svg";
import sharedConstants from "../../../shared/constants";

export interface SelectProps extends AntSelectProps<any> {}

const Select: React.FC<SelectProps> = (props: SelectProps) => {
  const { style, showSearch, placeholder, defaultValue, value, ...rest } =
    props;

  return (
    <AntSelect
      style={{
        width: "100%",
        ...style,
      }}
      menuItemSelectedIcon={<Check />}
      placeholder={placeholder || "선택"}
      showSearch={showSearch}
      filterOption={(input, option: any) => {
        if (input && option) {
          const { label } = option;
          return (
            typeof label === "string" &&
            label.toLowerCase().indexOf(input.toLowerCase()) !== -1
          );
        }

        return false;
      }}
      defaultValue={
        sharedConstants.defaultNull.includes(defaultValue)
          ? undefined
          : defaultValue
      }
      value={sharedConstants.defaultNull.includes(value) ? undefined : value}
      {...rest}
    />
  );
};

Select.defaultProps = {
  showSearch: false,
};
export default Select;
